module.exports = __webpack_public_path__ + "static/media/ky.cfcc8bbf.svg";